import { SxProps } from '@mui/material';

export const NavigationGroupDividerSX: SxProps = {
  mt: 0.25,
  mb: 1.25,
};
